// Класс диалога (успешного и не успешного).
class FunnySadDialog {

  static createFunnyDialog (title, description) {
    new FunnySadDialog(title, description, 'alert');
  }

  static createSadDialog (title, description) {
    new FunnySadDialog(title, description, 'error');
  }

  constructor(title, description, type) {
    this.type = type;

    let note = new Noty({
      theme: 'bootstrap-v4',
      type: type,
      layout: 'center',
      text: `<div class="title">
               ${title}
             </div>
             ${description}
      `,
      timeout: false,
      modal: true,
      closeWith: [],
      buttons: [
        Noty.button('Закрыть', `btn btn_color ${this._colorClass()} pull-right m-b-10`, function (n) {
          n.close()
        })
      ]
    });

    note.show();
  }

  _colorClass () {
    switch (this.type) {
      case 'alert':
        return '';
      case 'error':
        return 'btn_color_yellow';
      default:
        return '';
    }
  }
}

// Костыль для <script>
window.FunnySadDialog = FunnySadDialog;

export default FunnySadDialog;
